import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';

import { ProductService } from '../services/dataServices/product-service/productService';
import { OrganisationService } from '../services/dataServices/organisation-service/organisationservice';
import { ProductInterface } from '../model/products/product-interface';

@Injectable()
export class MarketplaceProductResolver implements Resolve<Promise<ProductInterface>> {
    constructor(
        private productService: ProductService,
        private organisationService: OrganisationService
    ) {}

    async resolve(route: ActivatedRouteSnapshot) {
        let product = parseInt(route.paramMap.get('productId'));

        // This prepares the Product Detail display
        await this.productService.setActiveProduct(product);
        if (this.productService.activeItem?.company) {
            await this.organisationService.setActiveItem(
                this.productService.activeItem.company
            );
        }
        return this.productService.activeItem;
    }
}
